/* Custom JS */
// ReCahrge - Change submit button text
window.addEventListener('load', function() {

  function insertAfter(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
  }

  function change_atc() {

    if( document.querySelector('.product-form__submit-preorder') ) {
      document.querySelector('.product-form .product-form__submit span').textContent = 'Pre-order';
      return;
    }

    if( document.getElementById('rc-radio2').checked ){
      document.querySelector('.product-form .product-form__submit span').textContent = 'Subscribe';

      var features = document.createElement('div');
      features.innerHTML = "<ul class='recharge__features'><li>cancel anytime</li><li>gift and 2x reward points with every order</li><li>free 30-day returns</li><li>free shipping</li></ul>";

      var recharge_container = document.querySelector('.rc-selling-plans-dropdown');

      insertAfter(features, recharge_container);

      // Monitor for change of selling plan
      var selling_plan_dropdown = document.querySelector('[name="rc_selling_plan"]');
      selling_plan_dropdown.addEventListener("change", function() {
        let selling_plan_id = selling_plan_dropdown.value;
        document.querySelector('.product-form-container [name="selling_plan"]').value = selling_plan_id;
      });      
    } else { 
      document.querySelector('.product-form .product-form__submit span').textContent = 'Add to bag';
    }

    // Check for data attribute and update textContent
    if( document.querySelector('.product-form__submit').hasAttribute('data-button-label') ) {
      document.querySelector('.product-form .product-form__submit span').textContent = document.querySelector('.product-form__submit').getAttribute('data-button-label');
    }

  }

  if( document.getElementById('rc-radio2') ) {
    change_atc();
  }

  // Monitor ReCharge radio buttons for change
  var recharge_radios = document.querySelectorAll('.rc-radio__input');  
  recharge_radios.forEach(radio => radio.addEventListener('change', () => change_atc()));

  // Add in dynamic title for ReCharge widget
  let sub_h3 = document.createElement('h3');
  sub_h3.classList.add('subscribe__title');
  sub_h3.textContent = "Choose your frequency:";

  let rcWidget = document.querySelector('.rc-widget');
  rcWidget.parentNode.insertBefore(sub_h3, rcWidget);

});

// Activate ZenDesk on button click
window.addEventListener('load', function() {
  const live_chat_triggers = document.querySelectorAll('[data-live-chat-trigger]');

  live_chat_triggers.forEach(function(button) {
    button.addEventListener('click', e => {
      e.preventDefault();
      zE('messenger', 'open');
    });
  });

});

// Mobile Filter Trigger
document.addEventListener("DOMContentLoaded", function(event) { 

  if( !document.querySelector("#ProductGridContainer") ) {
    return;
  }

  document.querySelector("#ProductGridContainer").addEventListener('click', function(e) {      
    if( e.target.parentNode.classList.contains('filtertrigger__link') ) {
      document.querySelector('.mobile-facets__open-wrapper').click();
    }
  });
});

// Footer Accordion
var show = function (elem) {
  elem.style.display = 'block';
};

var hide = function (elem) {
  elem.style.display = 'none';
};

var toggle = function (elem) {
  // If the element is visible, hide it
  if (window.getComputedStyle(elem).display === 'block') {
    hide(elem);
    return;
  }

  // Otherwise, show it
  show(elem);

};

document.addEventListener("DOMContentLoaded", function(event) {

  // New Customer - Home Classes
  document.querySelectorAll('.new-customer-landing-child').forEach(function(element) {
    element.parentElement.classList.add('new-customer-landing');
  });
    
  //Footer Accordion
  if(window.innerWidth <= 750) {

    const accordion_titles = document.querySelectorAll('.footer-block--menu .footer-block__heading');

    accordion_titles.forEach(function(title) {
      title.addEventListener('click', event => {
        var content = title.parentNode.querySelector('.footer-block__details-content');
        toggle(content);
      });
    });
  }

  // Article Product Accordion
  document.querySelectorAll('.article-sidebar-more a').forEach(function(button) {
    button.addEventListener('click', e => {

      e.preventDefault();

      if( button.innerHTML == "Show More" ) {
        button.innerHTML = "Show Less";

        document.querySelectorAll('.cont__box:not(.cont__box-first)').forEach(function(product) {
          product.classList.add('active');
        });

      } else {
        button.innerHTML = "Show More";

        document.querySelectorAll('.cont__box:not(.cont__box-first)').forEach(function(product) {
          product.classList.remove('active');
        });
      }
      
    });
  });

});

// Hide search icon until Searchanize has loaded
document.addEventListener("DOMContentLoaded", function () {
  let searchElement = document.querySelectorAll('.header__search'), i;
  for (i = 0; i < searchElement.length; ++i) {
    if (!searchElement[i].classList.contains('hidden')) return;
  }

  setTimeout(function(){
    for (i = 0; i < searchElement.length; ++i) {
      searchElement[i].classList.remove('hidden');
    }
  }, 2000);
}); 

// Initiate AOS
AOS.init();

// Globally update TOD for personalisation
document.addEventListener("DOMContentLoaded", function () {

  var currdate = dayjs().tz("Europe/London").format('HH:mm'),
      tod = 'morning';

  if( String(currdate) <= '12:00' ) {
    tod = 'morning';
  } else if( String(currdate) > '12:00' && String(currdate) < '18:00' ) {
    tod = 'afternoon';
  } else {
    tod = 'evening';
  }

  document.querySelectorAll('.personalise-tod').forEach(function(el) {
    el.innerHTML = tod;
  });
  
});

// Show name in header if set
document.addEventListener("DOMContentLoaded", function () {

  if( !document.querySelector(".customer--logged-in") ) {
    return;
  }

  var name_removal_delay = 5000;

  /*
  if (sessionStorage.getItem('pointsBalance') === null && sessionStorage.getItem('customerOptIn') === null) {
    $(document).on("swell:setup", function(){
      var customerDetails = swellAPI.getCustomerDetails();
      if (customerDetails.isOptIn) {
        sessionStorage.setItem('pointsBalance', customerDetails.pointsBalance);
      } else {
        sessionStorage.setItem('customerOptIn', '0');
      }
    });
  }*/

  document.querySelector('header.header').classList.add('personalise-customer-name');

  /*
  if (sessionStorage.getItem('pointsBalance') !== null) {
    var customerPoints = sessionStorage.getItem('pointsBalance'),
        customerOptIn = sessionStorage.getItem('customerOptIn');

    if( customerOptIn == '0' ) {
      var loyaltyMessage = 'start earning points';
    } else {
      if( customerPoints > 0 ) {
        var loyaltyMessage = 'your points balance: <span>' + customerPoints + '</span>';
      } else {
        var loyaltyMessage = 'keep earning rewards';
      }
    }
    
    document.querySelector('.header__customer-points h2 a').innerHTML = loyaltyMessage;
    name_removal_delay = 10000;

    setTimeout(function() {
      document.querySelector('header.header').classList.add('personalise-customer-points');
    }, 5000);

  }
  */

  setTimeout(function() {
    document.querySelector('header.header').classList.remove('personalise-customer-name', 'personalise-customer-points');
  }, name_removal_delay);

});

document.addEventListener("DOMContentLoaded", function () {

  // Menu Body Blue
  var body = document.querySelector('#MainContent');

  document.querySelectorAll('.mega-menu').forEach(function(megaMenu) {
    megaMenu.addEventListener('mouseenter', function() {
      body.classList.add('menu_blur');
    });
  
    megaMenu.addEventListener('mouseleave', function() {
      body.classList.remove('menu_blur');
    });
  });
  
});
